import { render } from "./MainScreenView.vue?vue&type=template&id=6e496484&scoped=true"
import script from "./MainScreenView.vue?vue&type=script&lang=js"
export * from "./MainScreenView.vue?vue&type=script&lang=js"

import "./MainScreenView.vue?vue&type=style&index=0&id=6e496484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e496484"]])

export default __exports__